import { createMuiTheme } from "@material-ui/core/styles";

export default createMuiTheme({
    palette: {
        primary: {
            main: "#9aad45",
            contrastText: "#fff"
        },
        secondary: {
            main: "#5845ad"
        }
    },
    typography: {
        fontFamily: "Roboto"
    },
    overrides: {
        MuiCssBaseline: {
            "@global": {
                "backgroundColor": "#f5f5f5"
            }
        }
    }
})

export const colors = {
	green: "#9aad45",
	darkGreen: "#8a9b3e",
	black: "#272930",
	grey: "#f7f7f7",
	focusedBackgroundGreen: "#f5f7ec",
	red: "#cc324b",
	orange: "#fcb150",
	darkBlue: "#50597b",
	lightBlue: "#4fc4f6",
	darkerBlue: "#1f253d",
	lightGreen: "#11a8ab",
	blue: "#3468af",
	darkGrey: "#7F7F7F"
};